import React from 'react';

const RoleManagement = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white shadow">
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="flex items-center justify-between py-4">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Role Management</h1>
              <p className="mt-2 text-sm text-gray-600">Create and manage custom roles for your sub-accounts

</p>
            </div>
          </div>
        </div>
      </div>
      <div className="px-4 py-8 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="p-8 text-center bg-white rounded-lg shadow">
          <p className="text-gray-500">Role management coming soon...</p>
        </div>
      </div>
    </div>
  );
};

export default RoleManagement;

